<div class="login-page">
    <div class="login-container">
        <img src="logo.png" alt="Logo" class="logo" height="40"/>
        <div class="login-form-container">
            <form [formGroup]="loginForm" autocomplete="off" (ngSubmit)="onSubmit()">
                <h2 class="login-title">Login</h2>

                <div class="login-error w-full" *ngIf="logoutMessage">
                    {{ logoutMessage }}
                </div>

                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Username</mat-label>
                    <input 
                        matInput 
                        type="text"
                        formControlName="username" 
                        required>
                        <mat-error *ngIf="loginForm.get('username')?.hasError('required')">
                            Username is required
                        </mat-error>
                        <mat-error *ngIf="loginForm.get('username')?.hasError('usernameOrPhone')">
                            Must be a valid username or 10-digit phone number
                        </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Password </mat-label>
                    <input 
                        matInput
                        type="password" 
                        formControlName="password" 
                        required>
                        <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
                            Password is required
                        </mat-error>
                        <mat-error *ngIf="loginForm.get('password')?.hasError('invalidCredentials')">
                            Invalid username or password
                        </mat-error>
                </mat-form-field>
                
                <div class="login-error w-full" *ngIf="invalidCredentials">
                    Invalid username or password
                </div>

                <button
                    mat-raised-button
                    class="w-full"
                    type="submit"
                    [disabled]="!loginForm.valid || invalidCredentials || isLoading">

                    <ng-container *ngIf="!isLoading; else loading">
                        Sign In
                    </ng-container>

                    <ng-template #loading>
                        <mat-progress-spinner
                        diameter="20"
                        mode="indeterminate"
                        color="accent">
                        </mat-progress-spinner>
                    </ng-template>
                </button>

                <div class="reset-password-link">
                    <a (click)="navigateToResetPassword()">Reset your password?</a>
                </div>
            </form>
        </div>
    </div>
</div>